import { all, fork, select, takeLatest } from 'typed-redux-saga/macro';

import {
  selectPermissions,
  TRY_PERMISSION,
  TryPermissionPayload,
} from '@user-permissions';

interface Action<P> {
  type: string;
  payload: P;
}

export function* userPermissionsSagas() {
  yield* all([fork(onFetchUserSuccess)]);
}

export function* onFetchUserSuccess() {
  yield* takeLatest(TRY_PERMISSION, tryPermission);
}

export function* tryPermission(action: Action<TryPermissionPayload>) {
  const {
    payload: { permissionKey, onAllow, onBlock },
  } = action;
  const {
    [permissionKey]: [allow, , actions],
  } = yield* select(selectPermissions);

  if (allow && onAllow) {
    yield* onAllow();
  }
  if (!allow && onBlock) {
    yield* onBlock();
  }
  if (actions) {
    yield* actions();
  }
}
